import { render, staticRenderFns } from "./BackAndTitle.vue?vue&type=template&id=75f31f8d&"
import script from "./BackAndTitle.vue?vue&type=script&lang=ts&"
export * from "./BackAndTitle.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports